import { Routes, Route, Navigate } from "react-router-dom";
import { lazy } from "react";
import withFeatureRestriction from "../utils/withFeatureRestriction";

// ONLY Receptionist
const ReceptionDashboard = lazy(() =>
  import("../screens/ReceptionistRole/Dashboard")
);
const ReceptionistAppointments = lazy(() => import("../screens/Appointments"));
const ReceptionistPatients = lazy(() =>
  import("../screens/ReceptionistRole/Patients")
);
const ReceptionistSettings = lazy(() =>
  import("../screens/ReceptionistRole/Settings")
);

// COMMON WITH OTHER ROLES
const PatientProfile = lazy(() => import("../screens/Patients/PatientProfile"));
const CreatePatient = lazy(() => import("../screens/Patients/CreatePatient"));

const Invoices = lazy(() => import("../screens//Invoices/Invoices"));
const CreateInvoice = lazy(() => import("../screens/Invoices/CreateInvoice"));
const CreatePreventiv = lazy(() =>
  import("../screens/Invoices/CreatePreventiv")
);
const EditInvoice = lazy(() => import("../screens/Invoices/EditInvoice"));
const PreviewInvoice = lazy(() => import("../screens/Invoices/PreviewInvoice"));

const Payments = lazy(() => import("../screens/Payments/Payments.js"));
const EditPayment = lazy(() => import("../screens/Payments/EditPayment"));
const PreviewPayment = lazy(() => import("../screens/Payments/PreviewPayment"));

const Doctors = lazy(() => import("../screens/Doctors/Doctors"));
const DoctorProfile = lazy(() => import("../screens/Doctors/DoctorProfile"));

const Schedule = lazy(() => import("../screens/Schedule.js"));

const NewMedicalRecord = lazy(() => import("../screens/NewMedicalRecord"));

const WithFeatureSchedule = withFeatureRestriction(Schedule, "schedule");
const WithFeatureInvoices = withFeatureRestriction(Invoices, "invoices");
const WithFeatureCreateInvoice = withFeatureRestriction(
  CreateInvoice,
  "invoices"
);
const WithFeatureCreatePreventiv = withFeatureRestriction(
  CreatePreventiv,
  "invoices"
);
const WithFeatureEditInvoice = withFeatureRestriction(EditInvoice, "invoices");
const WithFeaturePreviewInvoice = withFeatureRestriction(
  PreviewInvoice,
  "invoices"
);

const WithFeaturePayments = withFeatureRestriction(Payments, "payments");
const WithFeatureEditPayment = withFeatureRestriction(EditPayment, "payments");
const WithFeaturePreviewPayment = withFeatureRestriction(
  PreviewPayment,
  "payments"
);

export default function ReceptionRoutes() {
  return (
    <Routes>
      <Route path="/" element={<ReceptionDashboard />} />
      <Route path="appointments" element={<ReceptionistAppointments />} />

      <Route path="doctors" element={<Doctors />} />
      <Route path="doctors/:id" element={<DoctorProfile />} />

      <Route path="patients" element={<ReceptionistPatients />} />
      <Route path="patients/create" element={<CreatePatient />} />
      <Route path="patients/:id" element={<PatientProfile />} />
      <Route path="patients/visiting/:id" element={<NewMedicalRecord />} />

      <Route path="settings" element={<ReceptionistSettings />} />

      {/* WITH FEATURE RESTRICTION */}
      {/* <Route path="schedule" element={<WithFeatureSchedule />} /> */}

      <Route path="invoices" element={<WithFeatureInvoices />} />
      <Route path="invoices/create" element={<WithFeatureCreateInvoice />} />
      <Route
        path="invoices/preventiv/create"
        element={<WithFeatureCreatePreventiv />}
      />
      <Route path="invoices/edit/:id" element={<WithFeatureEditInvoice />} />
      <Route
        path="invoices/preview/:id"
        element={<WithFeaturePreviewInvoice />}
      />

      <Route path="payments" element={<WithFeaturePayments />} />
      <Route path="payments/edit/:id" element={<WithFeatureEditPayment />} />
      <Route
        path="payments/preview/:id"
        element={<WithFeaturePreviewPayment />}
      />

      <Route path="*" element={<Navigate to="/receptionist" replace />} />
    </Routes>
  );
}
